/**
 * Конфиг подарков: изображения в public/gifts/, цены в USD.
 */
const GIFTS = [
  { id: 'warning', name: 'Warning', imageUrl: '/gifts/Warning.png', price: 10 },
  { id: 'roses', name: 'Roses', imageUrl: '/gifts/Roses.png', price: 40 },
  { id: 'rose', name: 'Rose', imageUrl: '/gifts/Rose.png', price: 2 },
  { id: 'moon', name: 'Moon', imageUrl: '/gifts/Moon.png', price: 20 },
  { id: 'letter', name: 'Letter', imageUrl: '/gifts/Letter.png', price: 6 },
  { id: 'heart', name: 'Heart', imageUrl: '/gifts/Heart.png', price: 4 }
]

const FALLBACK_GIFT_IMAGE = '/gifts/Heart.png'

const byName = new Map(GIFTS.map((g) => [g.name.toLowerCase(), g]))
const byId = new Map(GIFTS.map((g) => [g.id, g]))

export { GIFTS }

export function getGiftByName(name) {
  if (!name || typeof name !== 'string') return null
  return byName.get(name.toLowerCase().trim()) || byId.get(name.toLowerCase().trim()) || null
}

export function getGiftById(id) {
  return byId.get(id) || null
}

export function getGiftImageUrl(gift) {
  return gift?.imageUrl || FALLBACK_GIFT_IMAGE
}
